'use es6';

import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/_jsx(UIIcon, {
  name: "spacer"
});